import apiClient from '../../axios';

const state = {
  creditInfo: {},
};

const mutations = {
  'SET_CREDITS_INFO' (state, creditInfo) {
    state.creditInfo = creditInfo;
  },
};

const actions = {
  getCreditsInfo: ({commit}) => {
    return apiClient.get("webstore/user/creditcard")
      .then((results) => {
          commit('SET_CREDITS_INFO', results.data);
          return results.data;
        },
      )
      .catch((err) => {
        return err.response.data
      });
  },
  deleteCreditsInfo: ({ commit }, formData) => {
    return apiClient.post("webstore/user/creditcard/delete", formData)
      .then((results) => {
          commit('SET_CREDITS_INFO', {});
          return results.data;
        },
      )
      .catch((err) => {
        return err.response.data
      });
  },
  editCreditsInfo: ({ commit }, formData) => {
    return apiClient.post("webstore/user/creditcard/edit", formData)
      .then((results) => {
          return results.data;
        },
      )
      .catch((err) => {
        return err.response.data
      });
  }
};

const getters = {
  creditInfo: state => {
    return state.creditInfo;
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/credits.js